/* eslint-disable @typescript-eslint/no-explicit-any */
// Source: https://stackoverflow.com/a/37154736/11259799

import { Observable, from } from 'rxjs';

export const evalWorkerCode = (_this: WindowOrWorkerGlobalScope) => {
  // Create a reference to the original postMessage and addEventListener functions before deleting everything unallowed
  const origPostMessage = postMessage;
  const origAddEventListener = addEventListener;

  // encapasulate the delete operation in a function to avoid leaking the original this object
  ((obj) => {
    let current = obj;
    const keepProperties = [
      // Required
      'Object',
      'Function',
      'Infinity',
      'NaN',
      'undefined',
      'caches',
      'TEMPORARY',
      'PERSISTENT',
      // Optional, but trivial to get back
      'Array',
      'Boolean',
      'Number',
      'String',
      'Symbol',
      // Optional
      'Map',
      'Math',
      'Set',
      'JSON',
      'console',
    ];

    do {
      Object.getOwnPropertyNames(current).forEach((name) => {
        if (keepProperties.indexOf(name) === -1) {
          delete current[name as keyof typeof current];
        }
      });

      current = Object.getPrototypeOf(current);
    } while (current !== Object.prototype);
  })(_this as WindowOrWorkerGlobalScope);

  origAddEventListener('message', (e) => {
    const values = Object.values(e.data.context);

    const f = new Function(...Object.keys(e.data.context), e.data.code);
    origPostMessage(f(...values));
  });
};

export function safeEvalWithParams(
  untrustedCode: string,
  context: { [id: string]: unknown },
): Observable<any> {
  return from(
    new Promise((resolve, reject) => {
      // Prepare a blob containing the function to execute
      const blobURL = URL.createObjectURL(
        new Blob(['(', evalWorkerCode.toString(), ')(this)'], {
          type: 'application/javascript',
        }),
      );

      // create a worker
      const worker = new Worker(blobURL);
      URL.revokeObjectURL(blobURL);

      // listen for messages from the worker
      worker.onmessage = (evt) => {
        worker.terminate();
        resolve(evt.data);
      };
      worker.onerror = (evt) => {
        reject(new Error(evt.message));
      };

      // send the code to the worker
      worker.postMessage({ code: untrustedCode, context });

      // kill the worker if it takes too long
      setTimeout(() => {
        worker.terminate();
        reject(new Error('RuntimeError: The worker timed out.'));
      }, 1000);
    }),
  );
}
